<template>
    <div>
      <swiper ref="mySwiper" :options="swiperOption">
        <swiper-slide>
          1111111111ddddd
        </swiper-slide>
        <swiper-slide>
          2
        </swiper-slide>
        <swiper-slide >
          3
        </swiper-slide>
      </swiper>
    </div>
  </template>
  
  <script>

  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  
  export default {
    name: 'test3333',
    components: {

      swiper,
      swiperSlide
    },
    data() {
      
      return {

       swiperOption: {
        autoplay: 3000,  // Swiper 4.x 的配置格式
        speed: 1000,
       },
      }
        
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper
      }
    },
    mounted() {
    
    },
    created() {

    },
    methods: {

    }
  }
  </script>
  <style lang="less">

  </style>
  